import { useQuery } from "@tanstack/react-query";
import { calculatePerformance, type ComponentPerformance, type ProductInfo } from "../services/performanceService";

interface UseProductPerformanceParams {
	defaultProductName: string | null;
	products: ProductInfo[];
	productType: string | null;
	enabled?: boolean;
}

export function useProductPerformance({
	defaultProductName,
	products,
	productType,
	enabled = true,
}: UseProductPerformanceParams) {
	return useQuery<ComponentPerformance[], Error>({
		queryKey: ["productPerformance", defaultProductName, productType, products],
		queryFn: async () => {
			if (!defaultProductName || products.length === 0) {
				return [];
			}

			const response = await calculatePerformance({
				defaultProductName,
				products,
				productType
			});

			return response.components;
		},
		enabled: enabled && !!defaultProductName && products.length > 0,
		staleTime: 5 * 60 * 1000,
	});
}